export default {
    ticketCreatedWithUploadFailures: 'Your ticket was created, but some attachments could not be confirmed. Open your ticket and check its files before attaching them again.',
    openCreatedTicket: 'Open your ticket',
    proofingTitle: "We couldn't open this review",
    proofingUnavailable: 'Please try again. If this keeps happening, contact support for help opening the review.',
    proofingAccess: "You don't have access to this review. Ask the person who shared it to give you access.",
    proofingMissing: "This review is no longer available. Ask the person who shared it for an updated link.",
    aiDisabled: 'AI features are turned off for this channel. Ask your channel admin for help.',
    signInAgain: 'Please sign in again, then return here to continue.',
    tryAgain: 'Try again',
    requesting: 'Requesting another attempt…',
    scoreFailedTitle: "We couldn't score this video",
    scoreFailed: 'Try again to request a new score. If this keeps happening, contact support.',
    uploadFailed: "We couldn't confirm this upload. Refresh the page and check the attached files before selecting this file again.",
    uploadTooLarge: 'This file is too large to attach. Choose a smaller file and try again.',
    uploadInvalid: "We couldn't accept this file. Check that you can open it on your device, then select it again.",
    uploadAccess: "You don't have permission to attach files here. Ask your channel admin for help.",
    uploadDestinationMissing: 'This item is no longer available. Reopen it before attaching files.',
    uploadTaskUnavailable: 'This task is no longer available here. Reopen the task before attaching files.',
}
